import { useQuery } from '@tanstack/react-query';
import API_URL from '../config';

const getAuthHeader = () => {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export function useLogs(filters = {}) {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '' && value !== 'All') {
      params.append(key, value);
    }
  });

  return useQuery({
    queryKey: ['email-logs', filters],
    queryFn: async () => {
      const response = await fetch(`${API_URL}/api/email/logs?${params.toString()}`, {
        headers: getAuthHeader(),
      });
      if (!response.ok) throw new Error('Failed to fetch email logs');
      return response.json();
    },
    refetchInterval: 30000,
  });
}
